<template>
  <div style="width: 100%; height: 100%">
    <div v-loading="loading" style="width: 100%; height: 100%">
      <el-row :gutter="20">
        <el-col :span="4" v-loading="leftLoading">
          <el-card
            style="height: calc(100vh - 130px); overflow-y: auto; width: 100%"
            :body-style="{
              padding: 0,
            }"
          >
            <div style="position: relative; padding: 20px">
              <div
                style="
                  position: sticky;
                  top: 0px;
                  left: 0px;
                  z-index: 999;
                  height: 60px;
                  display: flex;
                  align-items: center;
                  background-color: #fff;
                "
              >
                <el-input
                  placeholder="输入关键字进行过滤"
                  v-model="filterText"
                  @input="leftDataSearch"
                >
                </el-input>
              </div>
              <div style="margin-top: 10px">
                <el-tree
                  ref="tree"
                  :data="treeData"
                  :expand-on-click-node="false"
                  node-key="Id"
                  :props="defaultProps"
                  @node-click="handleNodeClick"
                  :filter-node-method="filterNode"
                  highlight-current
                  :indent="5"
                >
                </el-tree>
              </div>
            </div>
          </el-card>
        </el-col>

        <el-col :span="20" v-loading="rightLoading">
          <el-card
            style="height: calc(100vh - 130px); width: 100%; position: relative"
            body-style="padding:0px;height:100%; box-sizing: border-box;padding-top:10px"
            v-if="treeId"
          >
            <el-row :gutter="20" style="height: 120px">
              <el-col :span="12" style="height: 100%">
                <el-card
                  style="height: 100%"
                  body-style="padding: 0px 20px;width: 100%;height: 100%;"
                >
                  <el-row
                    style="
                      display: flex;
                      align-items: center;

                      height: 50%;
                    "
                  >
                    <el-button
                      type="primary"
                      @click="AddData"
                      icon="el-icon-plus"
                      v-if="treeLevel != 2"
                      >新建</el-button
                    >
                    <el-button
                      icon="el-icon-upload2"
                      type="warning"
                      @click="submitDataUp"
                      v-if="Grade == '1' || Grade == '3'"
                      >提交</el-button
                    >
                    <el-button
                      icon="el-icon-refresh
"
                      type="primary"
                      @click="getTableData"
                      >刷新</el-button
                    >

                    <el-button
                      type="primary"
                      icon="el-icon-document-copy"
                      @click="CopyDocument"
                      >复制文档</el-button
                    >
                  </el-row>
                  <el-row
                    style="
                      display: flex;
                      align-items: center;

                      height: 50%;
                    "
                  >
                    <el-select
                      v-if="Grade == '1' || Grade == '3'"
                      v-model="SearchSelectvalue"
                      clearable
                      filterable
                      placeholder="请选择分包商 "
                      style="width: 300px"
                    >
                      <el-option
                        v-for="item in SecondLevel"
                        :key="item.Id"
                        :value="item.Id"
                        :label="
                          item.cVenName
                            ? `${item.cVenName}【${item.cVenPhone}】`
                            : item.cVenPhone
                        "
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      placeholder="请输入设备名称进行搜索"
                      v-model="searchText"
                      clearable
                      style="width: 300px; margin-left: 20px"
                    >
                    </el-input>
                    <el-button
                      type="primary"
                      style="margin-left: 20px"
                      @click="search"
                      >查询</el-button
                    >
                  </el-row>
                </el-card>
              </el-col>
              <el-col :span="12" style="height: 100%">
                <el-row :gutter="20" style="height: 100%">
                  <el-col :span="8" style="height: 100%">
                    <el-card
                      style="width: 100%; height: 100%"
                      body-style="width: 100%; height: 100%;padding:0;padding-top:10px"
                    >
                      <div class="totalInfo-title" style="color: #e6a23c">
                        设备数量
                      </div>
                      <div class="DeviceCount">
                        {{ totalInfo.DeviceCount || 0 }}
                      </div>
                    </el-card>
                  </el-col>
                  <el-col :span="8" style="height: 100%">
                    <el-card
                      style="width: 100%; height: 100%; position: relative"
                      body-style="width: 100%; height: 100%;padding:0px;padding-top:10px"
                    >
                      <div class="totalInfo-title">提交率</div>
                      <div
                        style="
                          width: 100%;
                          height: calc(100% + 10px);
                          margin-top: 5px;
                        "
                        id="DeviceProgress"
                      ></div>
                    </el-card>
                  </el-col>
                  <el-col :span="8" style="height: 100%">
                    <el-card
                      style="width: 100%; height: 100%; position: relative"
                      body-style="width: 100%; height: 100%;padding:0;padding-top:10px"
                    >
                      <div class="totalInfo-title">通过率</div>
                      <div
                        style="
                          width: 100%;
                          height: calc(100% + 10px);
                          margin-top: 5px;
                        "
                        id="DocumentProgress"
                      ></div>
                    </el-card>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>

            <div
              style="height: calc(100% - 130px); width: 100%; padding: 0 20px"
            >
              <el-table
                :data="tableData"
                ref="table"
                size="mini"
                row-key="Id"
                height="calc(100% - 40px)"
                @selection-change="selectionChange"
                style="width: 100%; margin-top: 10px"
              >
                <el-table-column
                  type="selection"
                  width="50"
                  :selectable="selectable"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column
                  type="index"
                  width="50"
                  label="序号"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  label="设备编号"
                  prop="device_no"
                  align="center"
                  sortable
                  width="160"
                ></el-table-column>
                <el-table-column
                  label="设备名称"
                  prop="device_name"
                  align="center"
                  sortable
                  width="160"
                ></el-table-column>
                <el-table-column
                  label="设备规格"
                  prop="specification"
                  align="center"
                  sortable
                  width="160"
                ></el-table-column>
                <el-table-column
                  label="设备数量"
                  prop="Num"
                  align="center"
                  sortable
                  width="160"
                ></el-table-column>
                <el-table-column
                  label="安装日期"
                  prop="purchase_date"
                  align="center"
                  sortable
                  width="160"
                ></el-table-column>
                <el-table-column
                  label="供应商名称"
                  prop="cVenName"
                  align="center"
                  sortable
                  width="160"
                >
                </el-table-column>
                <el-table-column
                  label="生产厂家名称"
                  prop="manufacturer"
                  align="center"
                  sortable
                  width="160"
                >
                </el-table-column>
                <el-table-column
                  label="维修商名称"
                  prop="maintenance"
                  align="center"
                  sortable
                  width="160"
                >
                </el-table-column>
                <!-- <el-table-column
                v-for="item in columnList"
                :key="item.FiledKey"
                :label="item.FieldName"
                :prop="item.FiledKey"
              
              >
              </el-table-column> -->
                <!-- <el-table-column label="文档" prop="DocumentList" align="center" width="50">
                <template slot-scope="scope">
                  <el-popover placement="top" width="500" trigger="hover">
                    <span slot="reference" style="cursor: alias">......</span>
                    <el-table border size="mini" style="width: 100%">
                      <el-table-column label="文档类型" prop=""> </el-table-column>
                      <el-table-column label="文件信息" prop=""> </el-table-column>
                      <el-table-column label="文件大小" prop=""> </el-table-column>
                    </el-table>
                  </el-popover>
                </template>
              </el-table-column> -->

                <el-table-column
                  label="创建时间"
                  prop="CreateTime"
                  width="130"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{
                      moment(scope.row.CreateTime).format('YYYY-MM-DD HH:mm')
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="填写人"
                  prop="CreatorName"
                  width="130"
                  fixed="right"
                >
                </el-table-column>
                <el-table-column
                  label="状态"
                  prop="Status"
                  width="80"
                  align="center"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.Status == 0">已保存</el-tag>

                    <el-tag type="warning" v-if="scope.row.Status == 1"
                      >已提交</el-tag
                    >
                    <el-tag
                      type="success"
                      v-if="scope.row.Status == 2 || scope.row.Status == 3"
                      >已审核</el-tag
                    >
                    <el-tag type="danger" v-if="scope.row.Status == 4"
                      >已驳回</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  label="提交人"
                  prop="SubmitUserName"
                  width="130"
                  fixed="right"
                >
                </el-table-column>
                <el-table-column
                  label="填写进度"
                  prop="ProgressBar"
                  width="130"
                  align="center"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-progress
                      :text-inside="true"
                      :stroke-width="15"
                      text-color="#fff"
                      :percentage="scope.row.ProgressBar"
                    ></el-progress>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="op"
                  width="200"
                  label="操作"
                  align="center"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <!-- scope.row.SupplierId == base_Supplier.Id && -->
                    <el-button
                      @click="editData(scope.row)"
                      type="text"
                      v-if="scope.row.Status == 0 || scope.row.Status == 4"
                      >编辑</el-button
                    >
                    <el-button @click="ViewData(scope.row)" type="text"
                      >详情</el-button
                    >
                    <el-button @click="openInfo(scope.row)" type="text"
                      >记录</el-button
                    >
                    <el-button
                      @click="deleteData([scope.row.Id])"
                      type="text"
                      style="color: #f56c6c"
                      v-if="scope.row.Status == 0"
                      >删除</el-button
                    >
                    <!-- <el-button @click="ViewShare(scope.row)" type="text"
                    >共用文档信息</el-button
                  > -->
                  </template>
                </el-table-column>
              </el-table>
              <div
                style="
                  height: 40px;
                  display: flex;
                  align-items: center;
                  justify-content: right;
                "
              >
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pagination.currentPage"
                  :page-sizes="pagination.pageSizes"
                  :page-size="pagination.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="pagination.total"
                >
                </el-pagination>
              </div>
            </div>
          </el-card>
          <el-empty v-else>
            <span slot="description">
              <span style="font-size: 18px; font-weight: bold"
                >请选择下级设备分类</span
              >
            </span>
          </el-empty>
        </el-col>
      </el-row>
      <TemplateFormInfo
        ref="TemplateFormInfo"
        @success="getTableData"
      ></TemplateFormInfo>
      <TemplateFormFill
        ref="TemplateFormFill"
        @success="getTableData"
      ></TemplateFormFill>
      <TemplateFormCopyFill
        ref="TemplateFormCopyFill"
        @success="getTableData"
      ></TemplateFormCopyFill>
      <TemplateInfoStatistic
        ref="TemplateInfoStatistic"
      ></TemplateInfoStatistic>
    </div>
  </div>
</template>
<script>
import TokenCache from '@/utils/cache/TokenCache'
import TemplateFormInfo from './TemplateFormInfo.vue'
import TemplateFormFill from './TemplateFormFill.vue'
import TemplateFormCopyFill from './TemplateFormCopyFill.vue'
import moment from 'moment'
import TemplateInfoStatistic from './TemplateInfoStatistic'
import * as echarts from 'echarts'
export default {
  data() {
    return {
      SearchSelectvalue: '',
      SecondLevel: [],
      moment,
      searchText: '',
      leftLoading: false,
      rightLoading: false,
      TokenCache,
      // DataInfo.DeviceTab: "",
      ProjectInfo: {},
      token: '',
      loading: false,
      isLogin: false,

      ProjectId: '',
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'title',
      },

      treeId: '',
      treeLevel: '',
      treeName: '',
      base_Supplier: [],
      tableData: [],

      columnList: [],
      disabled: false,
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
        pageSizes: [20, 40, 80, 100],
      },
      selectionRows: [],
      Grade: null,
      totalInfo: {
        DeviceCount: '',
        tglv: '',
        tjilv: '',
      },
      // 添加图表实例存储
      chartInstances: [],
    }
  },
  updated() {
    this.$nextTick(() => {
      if (this.$refs.table) {
        this.$refs.table.doLayout()
      }
    })
  },
  props: {},
  components: {
    TemplateFormInfo,
    TemplateFormFill,
    TemplateFormCopyFill,
    TemplateInfoStatistic,
  },
  methods: {
    //删除
    deleteData(row) {
      this.$confirm('将删除该设备数据，删除后不可恢复，确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http
          .post(`/Device_TypeWork/Device_TypeTemplate/DeleteSupDeviceData`, row)
          .then((res) => {
            if (res.Success) {
              this.$notify.success('删除成功')
              this.pagination.currentPage = 1
              this.getTableData()
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    reactEchartsData() {
      this.$nextTick(() => {
        // 使用setTimeout确保DOM完全渲染
        setTimeout(() => {
          // 首先清理旧的图表实例
          this.disposeCharts()

          for (let index = 0; index < 2; index++) {
            var chartDom = document.getElementById(
              index == 0 ? 'DeviceProgress' : 'DocumentProgress'
            )
            if (!chartDom) continue

            var myChart = echarts.init(chartDom)
            // 将图表实例存储到数组中
            this.chartInstances.push(myChart)

            var option
            option = {
              tooltip: {
                appendToBody: true,
                formatter: '{a} : {c}%',
              },
              // 设置图表的网格，确保占满容器
              grid: {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
              },
              series: [
                {
                  name: index == 0 ? '提交率' : '通过率',
                  type: 'gauge',
                  startAngle: 180,
                  endAngle: 360,
                  min: 0,
                  max: 100,
                  splitNumber: 5,

                  radius: '100%', // 设置合适的半径，确保仪表盘占满容器
                  progress: {
                    show: true,
                    width: 6, //进度条宽度
                    itemStyle: {
                      color: index == 0 ? '#409eff' : '#67C23A',
                    },
                    roundCap: true,
                  },
                  // 外层轴线
                  axisLine: {
                    lineStyle: {
                      width: 6,
                    },
                  },
                  axisTick: {
                    //刻度线
                    show: true,
                    distance: 1,
                    length: 3,
                    lineStyle: {
                      width: 1,
                      color: '#999',
                    },
                  },
                  splitLine: {
                    //表盘内刻度文字上刻度线
                    distance: 1,
                    show: true, // 显示分割线
                    length: 5, // 分割线长度
                    lineStyle: {
                      width: 2,
                      color: '#999',
                    },
                  },
                  axisLabel: {
                    //表盘内刻度文字
                    distance: 8,
                    color: '#999',
                    fontSize: 10,
                  },
                  pointer: {
                    width: 3, // 指针宽度
                    length: '70%', // 指针长度
                    itemStyle: {
                      color: index == 0 ? '#409eff' : '#67C23A',
                    },
                  },
                  detail: {
                    formatter: '{value}%',
                    textStyle: {
                      fontSize: 14,
                      color: '#333',
                      fontWeight: 'bold',
                    },
                    offsetCenter: [0, 15], // 详细指标位置
                  },
                  data: [
                    {
                      value:
                        index == 0
                          ? this.totalInfo.tjilv || 0
                          : this.totalInfo.tglv || 0,
                    },
                  ],
                },
              ],
            }

            option && myChart.setOption(option)

            // 强制图表重新适应容器大小
            myChart.resize()
          }

          // 为所有图表添加窗口大小变化监听器
          this.addResizeListener()
        }, 100)
      })
    },
    // 添加清理图表实例的方法
    disposeCharts() {
      this.chartInstances.forEach((chart) => {
        if (chart && !chart.isDisposed()) {
          chart.dispose()
        }
      })
      this.chartInstances = []
    },
    // 添加窗口大小变化监听
    addResizeListener() {
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler)
      }

      this.resizeHandler = () => {
        this.chartInstances.forEach((chart) => {
          if (chart && !chart.isDisposed()) {
            chart.resize()
          }
        })
      }

      window.addEventListener('resize', this.resizeHandler)
    },
    openInfo(row) {
      this.$refs.TemplateInfoStatistic.openDrawer({
        ProjectId: this.ProjectId,
        InforType: 1,

        SupplierId: this.base_Supplier.Id,
        deviceId: row.Id,
      })
    },
    //批量复制文档
    CopyDocument() {
      if (this.selectionRows.length > 0) {
        this.$refs.TemplateFormCopyFill.openDrawer(
          [...this.selectionRows],
          this.treeId,
          this.treeName,
          this.ProjectId,
          this.base_Supplier.Id
        )
      } else {
        this.$notify.error('请选择设备后复制文档')
      }
    },
    getSecondLevel() {
      this.$http
        .post(
          '/Device_TypeWork/Device_TypeTemplate/GetProjectSupplierList?SupplierId=' +
            this.base_Supplier.Id
        )
        .then((res) => {
          if (res.Success) {
            this.SecondLevel = res.Data
          }
        })
    },
    search() {
      this.pagination.currentPage = 1
      this.getTableData()
    },
    selectable(row) {
      if (row.Status == 1 || row.Status == 2) {
        return false
      } else {
        return true
      }
    },
    ViewShare(row) {
      this.$refs.TemplateFormFill.openDrawer(
        [row],
        row.DeviceType,
        this.treeName,
        row.ProjectId,
        row.SupplierId,
        true
      )
    },
    selectionChange(rows) {
      this.selectionRows = rows
    },
    handleSizeChange(size) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = size
      this.getTableData()
    },
    handleCurrentChange(page) {
      this.pagination.currentPage = page
      this.getTableData()
    },
    getTableData() {
      this.rightLoading = true
      this.$http
        .post('/Device_TypeWork/Device_TypeTemplate/GetDeviceList', {
          SupplierId: this.base_Supplier.Id,
          ProjectId: this.base_Supplier.ProjectId,
          DeviceType: this.treeId,
          pageIndex: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          Keyword: this.searchText,
          SelectKeyword: this.SearchSelectvalue,
        })
        .then((res) => {
          this.rightLoading = false
          if (res.Success) {
            this.columnList = res.Data.TitleData
            this.pagination.total = res.Data.Total || 0
            this.tableData = res.Data.TableData || []
            this.totalInfo = {
              DeviceCount: res.Data.DeviceCount || 0,
              tglv: res.Data.tglv || 0,
              tjilv: res.Data.tjilv || 0,
            }
            this.reactEchartsData()
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    UpViewOpen() {
      if (this.selectionRows.length > 0) {
        this.$refs.TemplateFormFill.openDrawer(
          [...this.selectionRows],
          this.treeId,
          this.treeName,
          this.ProjectId,
          this.base_Supplier.Id
        )
      } else {
        this.$notify.error('请选择设备后上传')
      }
    },
    ViewData(row) {
      this.$refs.TemplateFormInfo.openDrawer(
        //树ID
        row.DeviceType,
        //项目ID
        row.ProjectId,
        //this.base_Supplier.Id 供应商ID
        row.SupplierId,
        //设备ID
        row.Id,
        //设备名称
        this.treeName,
        true
      )
    },
    editData(row) {
      this.$refs.TemplateFormInfo.openDrawer(
        //树ID
        row.DeviceType,
        //项目ID
        row.ProjectId,
        //this.base_Supplier.Id 供应商ID
        row.SupplierId,
        //设备ID
        row.Id,
        `${this.treeName}`
      )
    },
    AddData() {
      if (!this.treeId) {
        return this.$notify.error('请选择设备设备分类后新建')
      }
      this.$refs.TemplateFormInfo.openDrawer(
        this.treeId,
        this.ProjectId,
        this.base_Supplier.Id,
        '',
        `${this.treeName}`
      )
    },
    submitDataUp() {
      if (this.selectionRows.length > 0) {
        this.$confirm('确定提交当前设备数据吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.loading = true
          this.$http
            .post(`/Device_TypeWork/Device_TypeTemplate/SubmitSupplierData`, {
              DeviceIds: this.selectionRows.map((val) => val.Id),
              DeviceType: this.treeId,
              ProjectId: this.ProjectId,
              SupplierId: this.base_Supplier.Id,
            })
            .then((res) => {
              this.loading = false
              if (res.Success) {
                this.$notify.success('提交成功')
                this.getTableData()
              } else {
                this.$notify.error(res.Msg)
              }
            })
        })
      } else {
        this.$notify.error('请选择设备后提交')
      }
    },

    //树过滤节点
    filterNode(value, data) {
      if (!value) return true
      return data.title.indexOf(value) !== -1
    },
    handleNodeClick(data) {
      console.log(data, 'ddd')
      this.treeLevel = data.Level
      this.treeId = data.Id
      this.$refs.tree.setCurrentKey(this.treeId)
      this.treeName = data.title
      this.getTableData()
      // if (data.Level <= 2) {
      //   if (this.treeId) {
      //     this.$refs.tree.setCurrentKey(this.treeId)
      //   }
      // } else {
      //   this.treeId = data.Id
      //   this.$refs.tree.setCurrentKey(this.treeId)
      //   this.treeName = data.title
      //   this.getTableData()
      // }
    },
    getTreeData() {
      this.leftLoading = true
      this.$http
        .post('/Device_TypeWork/Device_TypeTemplate/GetTemplateData', {
          ProjectId: this.ProjectId,
          SupplierId: this.base_Supplier.Id,
        })
        .then((res) => {
          this.leftLoading = false
          if (res.Success) {
            this.treeData = res.Data.Data[0].children
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    leftDataSearch() {
      this.$refs.tree.filter(this.filterText)
    },
  },
  mounted() {},
  created() {
    this.ProjectInfo = window.localStorage.getItem('ProjectInfo')
      ? JSON.parse(window.localStorage.getItem('ProjectInfo'))
      : {}
    this.ProjectId = this.ProjectInfo.Id
    this.base_Supplier = window.localStorage.getItem('base_Supplier')
      ? JSON.parse(window.localStorage.getItem('base_Supplier'))
      : {}
    this.Grade = window.localStorage.getItem('Grade')
    this.getSecondLevel()
    this.getTreeData()
  },
  beforeDestroy() {
    // 组件销毁前清理图表实例和事件监听器
    this.disposeCharts()
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler)
      this.resizeHandler = null
    }
  },
  computed: {
    Tableheight() {
      return document.documentElement.clientHeight - 300
    },
  },
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-tree-node {
  white-space: normal;
}

::v-deep .el-tree-node__content {
  height: 100%;
  align-items: start;
}

::v-deep .el-tree-node {
  padding-top: 2px;
  padding-bottom: 2px;
}

::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #409eff;
  color: #fff;
  font-weight: bold;
}
::v-deep .el-tree-node {
  white-space: normal;
  .el-tree-node__content {
    height: 100%;
  }
}
::v-deep .el-table th .cell {
  font-weight: bold;
  font-size: 14px;
}
::v-deep .el-table__fixed-right {
  height: 100% !important;
}
/* 处理表格表头和内容错位问题 */
::v-deep .el-table th.gutter {
  display: table-cell !important;
}
.totalInfo-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  line-height: 20px;
  height: 20px;
  // color: #e6a23c;
}
.DeviceCount {
  font-size: 22px;
  font-weight: bold;
  color: #e6a23c;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 30px);
}
</style>
